import {BrandProductsList} from "../BrandProductList";
import {useNavigate, useParams} from "react-router-dom";
import {ParamBrandHouse} from "../../../Parameters";
import PageHeader from "../../../layout/PageHeader";
import * as React from "react";
import {useState} from "react";
import Page from "../../../layout/Page";
import PageContent from "../../../layout/PageContent";
import {MasterDataEditorCreatePath, MasterDataEditorPath} from "./MasterDataEditPage";
import Button from "@mui/material/Button";
import {Divider, Menu, MenuItem} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {MasterDataGroups} from "./MasterDataGroups";
import {
   useMasterDataSyncBrandMutation,
   useMasterDataSyncShopMutation,
   useMasterDataPageShopsQuery
} from "../../../Queries";
import {SavingUI} from "../../../SavingProvider";
import {useRecoilValue} from "recoil";
import {CurrentUserIsAdmin} from "../../../atoms/CurrentUser";

export const MasterDataPage = () => {
   const [groupId, setGroupId] = React.useState<string | undefined>(undefined);
   const [showGroupsDialog, setShowGroupsDialog] = useState(false);
   const [syncAnchorEl, setSyncAnchorEl] = useState<null | HTMLElement>(null);
   const {brandHouseId} = useParams<ParamBrandHouse>();
   const isAdmin = useRecoilValue(CurrentUserIsAdmin);
   const navigate = useNavigate();
   const [syncBrand] = useMasterDataSyncBrandMutation();
   const [syncShop] = useMasterDataSyncShopMutation();

   const {data: shopsData} = useMasterDataPageShopsQuery({
      variables: {brandHouseId: brandHouseId!},
      skip: !brandHouseId
   });

   const shops = shopsData?.ShopMany || [];

   const onCreate = () => {
      if (groupId) {
         navigate(MasterDataEditorCreatePath(brandHouseId, groupId));
      }
   }

   const onTabChange = (groupId: string) => {
      setGroupId(groupId)
   }

   const handleOpenGroups = () => {
      setShowGroupsDialog(true);
   }

   const handleCloseGroups = () => {
      setShowGroupsDialog(false);
   }

   const onSynchronizeBrand = async () => {
      setSyncAnchorEl(null);
      if (!brandHouseId) return;
      await SavingUI.process(async () => {
         await syncBrand({variables: {refId: brandHouseId, arguments: [brandHouseId, true]}});
      }, 'Synchronizing brand');
   }

   const onSynchronizeShop = async (shopId: string, shopName: string) => {
      setSyncAnchorEl(null);
      await SavingUI.process(async () => {
         await syncShop({variables: {refId: shopId, arguments: [shopId, true]}});
      }, 'Synchronizing ' + shopName);
   }

   return <Page>
      <PageHeader title={"Master Data"}>
         {isAdmin && <>
            <Button
               variant={"outlined"}
               onClick={(e) => setSyncAnchorEl(e.currentTarget)}
               endIcon={<ArrowDropDownIcon/>}
               sx={{marginRight: 1}}
            >
               Synchronize
            </Button>
            <Menu
               anchorEl={syncAnchorEl}
               open={Boolean(syncAnchorEl)}
               onClose={() => setSyncAnchorEl(null)}
            >
               <MenuItem onClick={onSynchronizeBrand}>Brand</MenuItem>
               {shops.length > 0 && <Divider/>}
               {shops.map(shop => (
                  <MenuItem key={shop._id} onClick={() => onSynchronizeShop(shop._id, shop.name || shop._id)}>
                     {shop.name}
                  </MenuItem>
               ))}
            </Menu>
         </>}
         <Button
            variant={"outlined"}
            onClick={handleOpenGroups}
            sx={{marginRight: 1}}
         >
            Groups
         </Button>
         <Button variant={"contained"} onClick={onCreate}>
            Create
         </Button>
      </PageHeader>
      <PageContent>
         <BrandProductsList onTabChange={onTabChange} brandHouseId={brandHouseId} inDialog={false}
                            onProductSelect={(product) => {
                               navigate(MasterDataEditorPath(brandHouseId, product._id))
                            }}/>
      </PageContent>

      <MasterDataGroups
         open={showGroupsDialog}
         onClose={handleCloseGroups}
         brandHouseId={brandHouseId}
      />
   </Page>
}
